import React, { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  CCMetalPowderAutomizationData,
  CCMetalVolumePartReductionData,
  CCMetalCo2ePowderScenarioMData,
  CCMetalPowderAutomizationState,
  CCMetalGreenEnergyMixData,
  CCMetalInertGasReductionSMData,
  CCMetalCo2TotalTodaySMData,
  CCMetalCo2TotalTomorrowSMData,
  CCMetalVolumePartReductionState,
  CCMetalModeOfTransportNode1,
  CCMetalModeOfTransportNode2,
  CCMetalModeOfTranspotation1,
  CCMetalModeOfTranspotation2,
  CCMetalTotalTraspotation,
  CCMetalGreenEnergyMixDataInput,
} from "atoms/CCCarbonMetal/CCMetalScenario";

import {
  CCMetalCo2EmissionPowderDataM,
  CCMetalCo2EmissionFactorDataM,
  CCMetalCo2EmissionBuildProcessDataM,
  CCMetalCo2EmissionGasDataM,
} from "atoms/CCCarbonMetal/CCMetalCarbonContent";

import { CCMetalCo2ePerPartPMDataM } from "atoms/CCCarbonMetal/CCMetalPoweredMFG";

import {
  CCMetalCarbonEmissionFactorNode1DataM,
  CCMetalCarbonEmissionFactorNode2DataM,
  CCMetalMaterialTransportationDataM,
  CCMetalSystemTransportationDataM,
} from "atoms/CCCarbonMetal/CCMetalTransportation";
import { useRoundOffValue } from "app/components/hooks/useRoundOffValue";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import {
  PercentageData,
  YesNoData,
  LogisticsData,
} from "utils/selectDropdowns";
import SelectDropdown from "app/components/SelectDropdown";
import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";
import {
  PowederLogistics,
  systemPowederLogistics,
} from "app/view/Constant/TooltipText";

const MaterialTableValues1 = ({ Socket, staticDataOfMachine, isBold = false }) => {
  const [powderAutomization, setPowderAutomization] = useRecoilState(
    CCMetalPowderAutomizationData
  );
  const [volumePartReduction, setVolumePartReduction] = useRecoilState(
    CCMetalVolumePartReductionData
  );
  const [co2ePowder, setCo2EPowder] = useRecoilState(
    CCMetalCo2ePowderScenarioMData
  );
  const [greenEnergyMix, setGreenEnergyMix] = useRecoilState(
    CCMetalGreenEnergyMixData
  );
  const [inertGasReduction, setInertGasReduction] = useRecoilState(
    CCMetalInertGasReductionSMData
  );

  const [, setCo2TotalToday] = useRecoilState(
    CCMetalCo2TotalTodaySMData
  );

  const [, setCo2TotalTomorrow] = useRecoilState(
    CCMetalCo2TotalTomorrowSMData
  );
  const [powderAtomizationState, setPowderAutomizationState] = useRecoilState(
    CCMetalPowderAutomizationState
  );

  const [modeOfTransportnode1, setmodeOfTransportnode1] = useRecoilState(
    CCMetalModeOfTransportNode1
  );

  const [modeOfTransportnode2, setmodeOfTransportnode2] = useRecoilState(
    CCMetalModeOfTransportNode2
  );

  const [modeOfTranspotation1, setModeOfTranspotation1] = useRecoilState(
    CCMetalModeOfTranspotation1
  );
  const [modeOfTranspotation2, setModeOfTranspotation2] = useRecoilState(
    CCMetalModeOfTranspotation2
  );

  const co2EmissionPowder = useRecoilValue(CCMetalCo2EmissionPowderDataM);
  const CCMetalCo2ePerPartPMData = useRecoilValue(CCMetalCo2ePerPartPMDataM);
  const co2eEmissionFactor = useRecoilValue(CCMetalCo2EmissionFactorDataM);
  const materialTransportaion = useRecoilValue(
    CCMetalMaterialTransportationDataM
  );
  const systemTransportation = useRecoilValue(CCMetalSystemTransportationDataM);
  const cefnone = useRecoilValue(CCMetalCarbonEmissionFactorNode1DataM);
  const cefnTwo = useRecoilValue(CCMetalCarbonEmissionFactorNode2DataM);
  const co2EmissionBuildProcess = useRecoilValue(
    CCMetalCo2EmissionBuildProcessDataM
  );
  const [volumerPartReductionState, setVolumePartReductionState] =
    useRecoilState(CCMetalVolumePartReductionState);
  const [totalTranpotation, setTotalTraspotation] = useRecoilState(
    CCMetalTotalTraspotation
  );

  const co2EmissionGas = useRecoilValue(CCMetalCo2EmissionGasDataM);

  const [greenEnergymixState, setGreenEnergyMixState] = useRecoilState(CCMetalGreenEnergyMixDataInput);

  const { getComputedValue } = useRoundOffValue();

  useEffect(() => {
    if (modeOfTranspotation1 && modeOfTranspotation2) {
      Socket.off("*");

      Socket.emit("carbon-calculator", {
        key: "MSA-MCT",
        input: {
          node1_mode: modeOfTranspotation1,
          node2_mode: modeOfTranspotation2,
          material_transportation: parseInt(materialTransportaion),
          system_transportation: parseInt(systemTransportation),
          carbon_emission_factor_node_1: +cefnone,
          carbon_emission_factor_node_2: +cefnTwo,
          utilization: +staticDataOfMachine?.utilization?.value,
          build_time: +staticDataOfMachine?.build_time?.value,
          setup_time: +staticDataOfMachine?.setup_time?.value,
          unpacking_time_per_job:
            +staticDataOfMachine?.unpacking_time_per_job?.value,
        },
      });

      Socket.on("MSA-MCT", function (data) {
        let value_node_1_today = data?.data?.transport_node_1_today.toFixed(3)
        let value_node_1_tomorrow = data?.data?.transport_node_1_tomorrow.toFixed(3)
        let value_node_2_today = data?.data?.transport_node_2_today.toFixed(3)
        let value_node_2_tomorrow = data?.data?.transport_node_2_tomorrow.toFixed(3)

        const transportNode1Today = value_node_1_today.slice(-1) === '0' ? data?.data?.transport_node_1_today.toFixed(5) : value_node_1_today
        const transportNode1Tomorrow = value_node_1_tomorrow.slice(-1) === '0' ? data?.data?.transport_node_1_tomorrow.toFixed(5) : value_node_1_tomorrow

        const transportNode2Today = value_node_2_today.slice(-1) === '0' ? data?.data?.transport_node_2_today.toFixed(5) : value_node_2_today
        const transportNode2Tomorrow = value_node_2_tomorrow.slice(-1) === '0' ? data?.data?.transport_node_2_tomorrow.toFixed(5) : value_node_2_tomorrow

        setmodeOfTransportnode1({
          today: transportNode1Today,
          tomorrow: transportNode1Tomorrow,
        });
        setmodeOfTransportnode2({
          today: transportNode2Today,
          tomorrow: transportNode2Tomorrow,
        });
        setTotalTraspotation({
          today: ((transportNode1Today.length > 5) || (transportNode2Today.length > 5)) ? data?.data?.transport_today.toFixed(5) : getComputedValue(data?.data?.transport_today),
          tomorrow: ((transportNode1Tomorrow.length > 5) || (transportNode2Tomorrow.length > 5)) ? data?.data?.transport_tomorrow.toFixed(5) : getComputedValue(data?.data?.transport_tomorrow),
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modeOfTranspotation1, modeOfTranspotation2]);

  useEffect(() => {
    if (powderAtomizationState && volumerPartReductionState) {
      Socket.off("*");

      Socket.emit("carbon-calculator", {
        key: "MSA-MCP",
        input: {
          atomizedType: powderAtomizationState,
          co2_emission_powder: co2EmissionPowder,
          reduction_in_volume: volumerPartReductionState,
          powder_energy_per_part: CCMetalCo2ePerPartPMData,
          co2_emission_factor: co2eEmissionFactor,
          no_of_parts: parseInt(staticDataOfMachine?.no_of_parts?.value),
          part_volume: parseInt(staticDataOfMachine?.part_volume?.value),
          part_support_volume: parseInt(
            staticDataOfMachine?.part_support_volume?.value
          ),
          material_id: parseInt(staticDataOfMachine?.material_id?.value),
        },
      });

      Socket.on("MSA-MCP", function (data) {
        const valuepatod = getComputedValue(
          data?.data?.powder_atomization_today
        );
        const valuepatom = getComputedValue(
          data?.data?.powder_atomization_tomorrow
        );
        const valuecptod = getComputedValue(data?.data?.co2e_powder_today);
        const valuecptom = getComputedValue(data?.data?.co2e_powder_tomorrow);
        const valuevptod = getComputedValue(
          data?.data?.volume_of_the_part_reduction_today
        );
        const valuevptom = getComputedValue(
          data?.data?.volume_of_the_part_reduction_tomorrow
        );
        setPowderAutomization({ today: valuepatod, tomorrow: valuepatom });
        setCo2EPowder({ today: valuecptod, tomorrow: valuecptom });
        setVolumePartReduction({ today: valuevptod, tomorrow: valuevptom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [powderAtomizationState, volumerPartReductionState]);

  useEffect(() => {
    if (greenEnergymixState) {
      Socket.off("*");

      Socket.emit("carbon-calculator", {
        key: "MSA-MCE",
        input: {
          isGreenEnergyMix: greenEnergymixState,
          co2_emission_build_process: co2EmissionBuildProcess,
        },
      });

      Socket.on("MSA-MCE", function (data) {
        const valuepatod = getComputedValue(data.data.green_energy_mix_today);
        const valuepatom = getComputedValue(
          data.data.green_energy_mix_tomorrow
        );
        setGreenEnergyMix({ today: valuepatod, tomorrow: valuepatom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [greenEnergymixState]);

  useEffect(() => {
    if (co2EmissionGas) {
      Socket.off("*");

      Socket.emit("carbon-calculator", {
        key: "MSA-MCG",
        input: { co2_emission_gas: co2EmissionGas },
      });

      Socket.on("MSA-MCG", function (data) {
        const valuepatod = getComputedValue(
          data.data.inert_gas_reduction_today
        );
        const valuepatom = getComputedValue(
          data.data.inert_gas_reduction_tomorrow
        );
        setInertGasReduction({ today: valuepatod, tomorrow: greenEnergymixState === "yes" ? 0 : valuepatom });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [greenEnergymixState]);

  useEffect(() => {
    if (
      co2ePowder !== undefined &&
      greenEnergyMix !== undefined &&
      inertGasReduction !== undefined &&
      totalTranpotation !== undefined
    ) {
      const value =
        parseFloat(co2ePowder.today) +
        parseFloat(inertGasReduction.today) +
        parseFloat(totalTranpotation.today);
      const value1 = getComputedValue(value);
      setCo2TotalToday(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    co2ePowder,
    inertGasReduction,
    volumePartReduction,
    greenEnergyMix,
    totalTranpotation,
  ]);

  useEffect(() => {
    if (
      co2ePowder !== undefined &&
      greenEnergyMix !== undefined &&
      inertGasReduction !== undefined &&
      totalTranpotation !== undefined
    ) {
      const value =
        parseFloat(co2ePowder.tomorrow) +
        parseFloat(inertGasReduction.tomorrow) +
        parseFloat(totalTranpotation.tomorrow);
      const value1 = getComputedValue(value);

      setCo2TotalTomorrow(value1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    co2ePowder,
    inertGasReduction,
    volumePartReduction,
    greenEnergyMix,
    totalTranpotation,
  ]);

  return (
    <div className="d-flex flex-column gap-16">
      {/* CO2e Powder */}
      <div className="d-flex flex-column scenario_container">
        {/* heading */}
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Powder</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">
            <Tippy
              content={
                <span>
                  Here you can be playful! We have estimated the status quo of
                  your carbon and costs, but let's see how certain changes might
                  impact your values!
                </span>
              }
            >
              <span> Future Scenario</span>
            </Tippy>
          </div>
        </div>
        {/* : Question */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            How much volume reduction in % do you think is possible with
            redesign?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              Dataset={PercentageData}
              getState={volumerPartReductionState}
              setState={setVolumePartReductionState}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {volumePartReduction ? volumePartReduction.today : "_ _ _ _"}
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {volumePartReduction ? volumePartReduction.tomorrow : "_ _ _ _"}
          </div>
        </div>

        {/*  Total */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Powder (kg)
          </span>
          <div
            className={
              " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {co2ePowder ? co2ePowder.today : "_ _ _ "}
          </div>
          <div className="  scenario_cell">
            {co2ePowder ? co2ePowder.tomorrow : "_ _ _ "}
          </div>
        </div>
      </div>
      {/* CO2e Energy */}
      <div className="d-flex flex-column scenario_container">
        {/* heading */}
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Energy</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">
            <Tippy
              content={
                <span>
                  Here you can be playful! We have estimated the status quo of
                  your carbon and costs, but let's see how certain changes might
                  impact your values!
                </span>
              }
            >
              <span> Future Scenario</span>
            </Tippy>
          </div>
        </div>
        {/* : Question */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            Is there a possibility to switch to a green energy mix?
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              Dataset={YesNoData}
              getState={greenEnergymixState}
              setState={setGreenEnergyMixState}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {greenEnergyMix !== undefined ? greenEnergyMix.today : "_ _ _ _"}
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {greenEnergyMix !== undefined ? greenEnergyMix.tomorrow : "_ _ _ _"}
          </div>
        </div>

        {/* Inert Gas Reduction */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            Inert Gas Reduction
          </span>
          <div className=" scenario_cell ">
            &nbsp;
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {inertGasReduction !== undefined ? inertGasReduction.today : "_ _ _ _"}
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {inertGasReduction !== undefined ? inertGasReduction.tomorrow : "_ _ _ _"}
          </div>
        </div>

        {/*  Total */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Energy (kg)
          </span>
          <div
            className={
              " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {inertGasReduction !== undefined ? inertGasReduction.today : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {inertGasReduction !== undefined ? inertGasReduction.tomorrow : "_ _ _ _"}
          </div>
        </div>
      </div>

      {/* CO2e Logistics */}
      <div className="d-flex flex-column scenario_container">
        {/* heading */}
        <div className="d-flex gap-40 mb-24">
          <span className=" scenario_header">CO2e Logistics</span>
          <div className=" scenario_header">Input</div>
          <div className=" scenario_header"> Current Scenario</div>
          <div className=" scenario_header">
            <Tippy
              content={
                <span>
                  Here you can be playful! We have estimated the status quo of
                  your carbon and costs, but let's see how certain changes might
                  impact your values!
                </span>
              }
            >
              <span> Future Scenario</span>
            </Tippy>
          </div>
        </div>
        {/* : Question */}
        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            <TooltipTrippy
              tooltipMessage={systemPowederLogistics}
              fieldName="Change the mode of logistics (node 1)"
            />
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation1}
              getState={modeOfTranspotation1}
              Dataset={LogisticsData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div
            className={
              "font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.today
              : "_ _ _ _"}{" "}
          </div>
          <div
            className={
              "font-14 scenario_cell" + (!isBold ? "font-semi-bold" : "")
            }
          >
            {modeOfTransportnode1 !== undefined
              ? modeOfTransportnode1.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
        {/* : Question */}

        <div className="d-flex gap-40 pb-20 scenario_cell_divider">
          <span className="scenario_cell">
            <TooltipTrippy
              tooltipMessage={PowederLogistics}
              fieldName="Change the mode of logistics (node 2)"
            />
          </span>
          <div className=" scenario_cell select_wrapper">
            <SelectDropdown
              setState={setModeOfTranspotation2}
              getState={modeOfTranspotation2}
              Dataset={LogisticsData}
              styleclass="dropdown-input_select select_wrapper_text"
            />
          </div>
          <div
            className={
              " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.today
              : "_ _ _ _"}
          </div>
          <div
            className={
              " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            {modeOfTransportnode2 !== undefined
              ? modeOfTransportnode2.tomorrow
              : "_ _ _ _"}
          </div>
        </div>

        {/*  Total */}
        <div className="d-flex gap-40 font-14 font-weight-bold">
          <span className="scenario_cell font-14 font-weight-bold">
            CO2e Logistics (kg)
          </span>
          <div
            className={
              " font-14 scenario_cell " + (!isBold ? "font-semi-bold" : "")
            }
          >
            &nbsp;
          </div>
          <div className="  scenario_cell ">
            {totalTranpotation !== undefined
              ? totalTranpotation.today
              : "_ _ _ _"}
          </div>
          <div className="  scenario_cell">
            {totalTranpotation !== undefined
              ? totalTranpotation.tomorrow
              : "_ _ _ _"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaterialTableValues1;

